// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39Lfy","content":"styles_content__3hRSa","row":"styles_row__UuHM_","footer":"styles_footer__2FNx_","phraseLength":"styles_phraseLength__BJqu2"};